import useInvoiceManagementData from "@app/data-hooks/use-invoice-management-data.ts";
import { invoicePotentialItemsTableDefinition } from "@app/table-definitions/invoice-potential-items.table-definition.tsx";
import { Button } from "@mui/material";
import { DataTable } from "bi-lib";
import { useState } from "react";

interface Props {
    invoiceId: number;
    categoryId: number;
    maxHeight?: number;
    title?: string;
}

export default function InvoicePotentialItemsTable({ invoiceId, categoryId, title }: Props) {
    const [selectedItems, setSelectedItems] = useState<string[]>([]);

    const { potentialEntries, potentialEntriesTotals, updateIncludedItems } = useInvoiceManagementData({
        id: invoiceId,
        categoryId,
    });

    const allSelected =
        selectedItems != undefined && selectedItems.length > 0 && selectedItems.length == potentialEntries.data?.length;

    const handleSelectAllToggle = () => {
        if (allSelected) {
            setSelectedItems([]);
            return;
        }
        setSelectedItems(potentialEntries.data?.map((x) => x.entryId!) ?? []);
    };

    const handleSelectItem = (id: string) => {
        const index = selectedItems.indexOf(id);
        if (index == -1) {
            setSelectedItems([...selectedItems!, id]);
            return;
        }
        const tempSelectedItems = [...selectedItems!];
        tempSelectedItems.splice(index, 1);
        setSelectedItems(tempSelectedItems);
    };

    const handleUpdateIncludedItems = async () => {
        await updateIncludedItems.mutateAsync({
            entries: selectedItems,
            invoiceId,
            invoicerId: 0,
        });

        setSelectedItems([]);
    };

    return (
        <DataTable
            rowsPerPageOptions={[5000]}
            label={title}
            actions={
                <Button
                    variant={"contained"}
                    onClick={handleUpdateIncludedItems}
                    disabled={selectedItems.length == 0 || updateIncludedItems.isPending}
                >
                    Add to Invoice
                </Button>
            }
            columns={invoicePotentialItemsTableDefinition({
                allSelected,
                onSelectAll: handleSelectAllToggle,
                onSelect: handleSelectItem,
                selectedItems,
                quantityTotal: potentialEntriesTotals.data?.quantityTotal ?? 0,
                billAmountTotal: potentialEntriesTotals.data?.billingAmountTotal ?? 0,
                rowCount: potentialEntries.data?.length ?? 0,
            })}
            data={potentialEntries.data ?? []}
            queryHook={potentialEntries}
        />
    );
}
